export default "assets/images/icons/Flèches slider (1)-3188ce5c.svg";